<template>
  <v-dialog :value="value" persistent width="800">
    <v-form @submit.prevent="submit">
      <v-card class="pa-5">
        <v-card-title class="px-0 pt-0">
          Neuer Brief
          <v-spacer />
          <v-btn icon @click="closeDialog">
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-select
          dense
          outlined
          label="Vorlagenart"
          :items="types"
          v-model="type"
          @change="onSelectType"
        ></v-select>
        <v-select
          v-if="template"
          v-model="template"
          dense
          outlined
          label="Vorlage"
          :items="templates"
          item-text="bezeichnung"
          item-value="id"
          return-object
          @change="selectTemplate"
        ></v-select>
        <!-- Auswahl aus Vorlagenliste -->
        <template v-if="type === 'template'">
          <template v-if="template === null">
            <v-row v-if="loading">
              <v-col v-for="n in 3" :key="n" cols="4">
                <v-skeleton-loader type="card" />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                v-for="(vorlage, index) in templates"
                :key="`template-${index}`"
                cols="4"
              >
                <v-card
                  class="pa-5 overflow-hidden"
                  @click="selectTemplate(vorlage)"
                  max-height="192"
                >
                  <v-card-title class="pt-0 px-0 text-h6">
                    {{ vorlage.bezeichnung }}
                  </v-card-title>
                  <v-card-text
                    class="px-0"
                    v-html="cutString(vorlage.nachricht, 100)"
                  >
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <FormNewBrief
              v-model="formData"
              :user="user"
              :user-type="userType"
              :initial-ansprache="ansprache"
              :initial-ansprache-text="anspracheText"
              :initial-subject="subject"
              :initial-message="message"
              :initial-gruss-text="grussText"
              :initial-additional-text="additionalText"
            />
          </template>
        </template>
        <!-- Blanko -->
        <template v-else-if="type === 'blank'">
          <FormNewBrief v-model="formData" :user="user" :user-type="userType" />
        </template>
        <v-card-actions class="px-0 pb-0">
          <v-spacer />
          <v-btn depressed @click="closeDialog">Abbrechen</v-btn>
          <v-btn
            depressed
            :disabled="createButtonDisabled"
            type="submit"
            color="cta"
            class="white--text"
            >Erstellen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mdiClose } from "@mdi/js";
import ApiService from "@/services/ApiService";
import { getError } from "@/util/helpers";
import FormNewBrief from "@/components/forms/FormNewBrief.vue";

export default {
  name: "NewAnschreibenDialog",
  components: {
    FormNewBrief,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
    userType: {
      type: String,
      default: "interessent",
    },
  },
  data() {
    return {
      icons: {
        mdiClose,
      },
      formData: {},
      subject: null,
      message: null,
      adressAuswahl: ["Heimadresse", "Baustellenadresse"],
      selectedAdresstyp: "Heimadresse",
      selectedBauvorhaben: {},
      types: [
        { text: "Blanko", value: "blank" },
        { text: "Vorlage", value: "template" },
      ],
      type: null,
      ansprachen: [
        { text: "Persönlich (Du)", value: "du" },
        { text: "Förmlich (Sie)", value: "sie" },
      ],
      ansprache: "sie",
      anspracheText: "",
      grussText: "Mit freundlichen Grüßen",
      additionalText: "",
      templates: [],
      template: null,
      loading: false,
      generatingAnschreiben: false,
    };
  },
  watch: {
    type(val) {
      if (val === "template") {
        this.fetchBrieftemplates();
      }
    },
  },
  computed: {
    authUser() {
      return this.$store.state.user.authUser;
    },
    anrede() {
      let anrede = "";

      if (this.$props.user.anrede && this.$props.user.anrede.includes("Herr")) {
        anrede = "Sehr geehrter ";
      } else if (this.$props.userType === "dienstleister") {
        anrede = "Sehr geehrte Damen und Herren,";
      } else {
        anrede = "Sehr geehrte ";
      }

      return anrede;
    },
    hasBauvorhabenAdresse() {
      return (
        this.$props.user.bauvorhaben[0].strasse &&
        this.$props.user.bauvorhaben[0].hausnr &&
        this.$props.user.bauvorhaben[0].plz &&
        this.$props.user.bauvorhaben[0].ort
      );
    },
    createButtonDisabled() {
      return (
        !this.type ||
        (this.selectedAdresstyp === "Baustellenadresse" &&
          !this.hasBauvorhabenAdresse) ||
        (this.type === "template" && this.templates.length === 0)
      );
    },
  },
  methods: {
    async fetchBrieftemplates() {
      const query = {
        templateType: "brief",
        view: "personal",
      };

      this.loading = true;
      await ApiService.fetchTemplates(query)
        .then((res) => {
          this.templates = res.data.collection;
        })
        .catch((err) => {
          const notification = {
            type: "error",
            title: "Fehler",
            message: "Beim Laden der Vorlagen ist ein Fehler aufgetreten:",
            error: getError(err),
          };

          this.$store.commit("notifications/ADD", notification);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSelectType() {
      if (this.type === "template") {
        this.fetchBrieftemplates();
      } else {
        this.resetTemplate();
      }
    },
    resetTemplate() {
      this.template = null;
      this.ansprache = "sie";
      this.subject = null;
      this.message = "";
      this.grussText = "Mit freundlichen Grüßen";
      this.additionalText = "";
      this.selectedBauvorhaben = {};
      this.formData.ansprache = "sie";
      this.formData.subject = null;
      this.formData.message = "";
      this.formData.grussText = "Mit freundlichen Grüßen";
      this.formData.additionalText = "";
      this.formData.selectedBauvorhaben = {};
      this.formData.bauvorhabenId = null;
    },
    selectTemplate(template) {
      this.template = template;
      this.subject = this.template.betreff;
      this.ansprache = this.template.ansprache_typ;
      this.anspracheText = this.template.ansprache_text;
      this.message = this.template.nachricht;
      this.grussText = this.template.gruss_text;
      this.additionalText = this.template.zusatztext;
    },
    cutString(text, maxlength) {
      if (text.length <= maxlength) {
        return text;
      }
      return text.substr(0, maxlength) + "\u2026";
    },
    async submit() {
      const payload = {
        userType: this.$props.userType,
        userId: this.$props.user.id,
        templateType: this.type,
        templateId: this.template ? this.template.id : null,
        bauvorhabenId: this.formData.bauvorhabenId,
        ansprache: this.formData.ansprache,
        anspracheText:
          this.$props.userType === "dienstleister"
            ? "Sehr geehrte Damen und Herren,"
            : this.formData.anspracheText,
        subject: this.formData.subject,
        message: this.formData.message,
        grussText: this.formData.grussText,
        additionalText: this.formData.additionalText,
        adressTyp: this.formData.adressTyp,
      };

      this.generatingAnschreiben = true;
      await ApiService.generateCustomAnschreiben(payload)
        .then((res) => {
          this.$emit("submit");
          // this.resetTemplate();
          // this.type = null;
          const link = document.createElement("a");
          link.href = "data:application/pdf;base64," + res.data.filecontents;
          link.download = res.data.filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => {
          const notification = {
            type: "error",
            title: "Fehler beim Erstellen der Datei",
            error: getError(err),
          };

          this.$store.commit("notifications/ADD", notification);
        })
        .finally(() => {
          this.generatingAnschreiben = false;
        });
    },
    closeDialog() {
      this.template = null;
      this.type = null;
      this.ansprache = "sie";
      this.$emit("dialog:close");
    },
  },
};
</script>

<style scoped></style>
